<template>
  <div class="APSSIDUI03">
    <div class="top-option">
      <sag-form-datepicker
        label='日期選擇'
        :id="serviceName"
        :sagValue="initDate"
        @sagChangeEvent="dateMenager.changeEvent"
      />
    </div>
    <div style="padding-left: 10px;">
      看板說明：
      <br/>
      <ol>
        <li>分母(符合後述)已報工之製令單 / 已拋轉MES未結案的製令單，開工日小於當日，大於指定日</li>
        <li>分母(符合後述)已報工<span style="color: red">且入庫</span>之製令單 / 已拋轉MES未結案的製令單，開工日小於當日，大於指定日</li>
      </ol>
      
    </div>

    <div class="dashboard-group-mes">
      <div v-for="(item, index) in orderDashboard.MES_datas.value" :key="index">
        <div v-if="index % 4 === 1" class="dividing-line"></div>
  
        <div class="myDashboard">
          <div class="titleDashboard">{{ item.ItemMark }}</div>
          <vue-apex-charts
            type="radialBar"
            height="245"
            class="my-2"
            :options="goalOverviewRadialBar"
            :series="[item.TranRate]"
          />
          <b-row class="text-center mx-0">
            <b-col
              cols="6"
              class="border-top border-right d-flex align-items-between flex-column py-1"
            >
              <b-card-text class="text-muted mb-0">
                MES製令單數
              </b-card-text>
              <h3 class="font-weight-bolder mb-0">
                {{ item.WorkCnt }}
              </h3>
            </b-col>
    
            <b-col
              cols="6"
              class="border-top d-flex align-items-between flex-column py-1"
            >
              <b-card-text class="text-muted mb-0">
                已報工數
              </b-card-text>
              <h3 class="font-weight-bolder mb-0">
                {{ item.WorkReportCnt }}
              </h3>
            </b-col>
          </b-row>
          <div class="animate-border">
            <i></i>
            <i></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-group-erp">
      <div v-for="(item, index) in orderDashboard.ERP_datas.value" :key="index">
        <div v-if="index % 4 === 1" class="dividing-line"></div>
  
        <div class="myDashboard">
          <div class="titleDashboard">{{ item.ItemMark }}</div>
          <vue-apex-charts
            type="radialBar"
            height="245"
            class="my-2"
            :options="goalOverviewRadialBar2"
            :series="[item.TranRate]"
          />
          <b-row class="text-center mx-0">
            <b-col
              cols="6"
              class="border-top border-right d-flex align-items-between flex-column py-1"
            >
              <b-card-text class="text-muted mb-0">
                MES製令單數
              </b-card-text>
              <h3 class="font-weight-bolder mb-0">
                {{ item.WorkCnt }}
              </h3>
            </b-col>
    
            <b-col
              cols="6"
              class="border-top d-flex align-items-between flex-column py-1"
            >
              <b-card-text class="text-muted mb-0">
                已報工數
              </b-card-text>
              <h3 class="font-weight-bolder mb-0">
                {{ item.WorkReportCnt }}
              </h3>
            </b-col>
          </b-row>
          <div class="animate-border">
            <i></i>
            <i></i>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  BRow, 
  BCol, 
  BCard, 
  BCardHeader, 
  BCardText, 
  BCardBody, 
  BCardTitle, 
  BCardSubTitle,
} from 'bootstrap-vue'
import pageJs from './js'
import VueApexCharts from 'vue-apexcharts'
import tools from '@/sag-core/tools'
import SagFormDatepicker from '@/components/basic/SagFormDatepicker.vue'
import { ref, onMounted, onUnmounted, reactive, computed, nextTick } from '@vue/composition-api'

export default {
  components: {
    VueApexCharts,
    BRow,
    BCol,
    SagFormDatepicker,
    BCardText,
    BCard,
    BCardHeader,
    BCardBody, 
    BCardTitle,
    BCardSubTitle,
  },
  props: {
    cycleTime: {
      type: Number,
      default: 60000
    }
  },
  setup(props) {
    const {

    } = pageJs.page.pageInit()

    const serviceName = pageJs.page.pageInfo.serviceName
    const initDate = ref('2022/10/24')
    
    const cssSettingMenager = {
      themeIndex: ref(1),
      themeColor: [
        {
          baseColor: '#3cb6fd',
          strokeColor: '#ebe9f1',
          textHeadingColor: '#5e5873',
          goalStrokeColor2: '#ffa38b'
        },
        {
          baseColor: '#3cb6fd',
          strokeColor: '#ebe9f1',
          textHeadingColor: '#5e5873',
          goalStrokeColor2: '#5EFDE4'
        },
        {
          baseColor: '#cc26ff',
          strokeColor: '#ebe9f1',
          textHeadingColor: '#5e5873',
          goalStrokeColor2: '#EF95FA'
        }
      ],
      init(){
        nextTick(()=>{
          document.querySelector('.APSSIDUI03').style.setProperty(`--base`, cssSettingMenager.themeColor[cssSettingMenager.themeIndex.value].baseColor)
          document.querySelector('.APSSIDUI03').style.setProperty(`--base2`, cssSettingMenager.themeColor[2].baseColor)
        })
      }
    }

    const dateMenager = {
      changeEvent(e){
        tools.debug.log({tag: 'DEBUG', title: '確認傳入element', content: ''}, e, initDate.value)
        initDate.value = e.value
        repeat.stop()
        getData().then(()=>{
          repeat.start()
        })
      }
    }

    const repeat = {
      time: 0,
      interval: null,
      init(sec){
        this.time = sec
        this.interval = window.setInterval(getData, this.time)
      },
      stop(){
        window.clearInterval(this.interval)
        this.interval = null
      },
      start(){
        this.interval = window.setInterval(getData, this.time)
      },
    }

    const orderDashboard = {
      title: '業務簽核',
      initDate: initDate,
      MES_datas: ref([]),
      ERP_datas: ref([]),
      getData(){
        return new Promise((response, rej)=>{
          pageJs.api.apiConvertRateDashboardWorkReport({ Date: initDate.value }).then(res=>{
            tools.debug.log({tag: 'DEBUG', title: '確認apiGetAPSDashboard', content: ''}, res)

            if(Array.isArray(res) && res.length === 2){
              // 目的地
              const des = [this.MES_datas, this.ERP_datas]
              for(let i = 0; i < des.length; i++){
                const tar = res[i]
                const l = des[i].value
                if(Array.isArray(tar)){
                  // 全刪全新增
                  l.splice(0, l.length, ...tar)
                  l.splice(l.length, l.length - tar.length)
                }
              }
            }
            else throw "資料格式與數量不正確，請檢察程式碼"

            // tools.arrEx.clear(this.ERP_datas.value)
            // tools.arrEx.fill(this.ERP_datas.value, res)
            response()            
          })
        })
      },
    }

    const getData = ()=>{
      return new Promise((response, rej)=>{
        let over = 0b000
        orderDashboard.getData().then(()=>{
          over = over | 0b001
          if(over === 0b001){
            return response()
          }
        })
      })
    }
    
    getData().then(()=>{
      repeat.init(props.cycleTime)
      cssSettingMenager.init()
    })

    onUnmounted(()=>{
      window.clearInterval(repeat.interval)
    })

    return {
      orderDashboard,
      dateMenager,
      initDate,
      serviceName,
      goalOverviewRadialBar: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [cssSettingMenager.themeColor[cssSettingMenager.themeIndex.value].goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: cssSettingMenager.themeColor[cssSettingMenager.themeIndex.value].strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: cssSettingMenager.themeColor[cssSettingMenager.themeIndex.value].textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [cssSettingMenager.themeColor[cssSettingMenager.themeIndex.value].baseColor],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      goalOverviewRadialBar2: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [cssSettingMenager.themeColor[2].goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: cssSettingMenager.themeColor[2].strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: cssSettingMenager.themeColor[2].textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [cssSettingMenager.themeColor[2].baseColor],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/bootstrap-extended/include';

.APSSIDUI03 {
  --base: #3cb6fd;
  --base2: #cc26ff;

  @mixin dashboard-group-mes-color($color){
    // 分隔線
    .dividing-line{
      width: 100%;
      height: 2px;
      background-color: var($color);
      margin-top: 10px;
      margin-bottom: 10px;
      @media (min-width: (map-get($grid-breakpoints, md))) {
        width: 2px;
        height: 100%;
        background-color: var($color);
        margin: 0px;
      }
    }

    flex-wrap: wrap;
    .myDashboard{
      margin: auto;
      @media (min-width: (map-get($grid-breakpoints, md))) {
        margin: 10px;
      }
      .titleDashboard{
        margin-top: 10px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
      }

      position: relative;
      width: 300px;
      height: 350px;
      overflow: hidden;
      
      .animate-border{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        &::before, &::after{
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
        }
        i{
          position: absolute;
          display: inline-block;
          width: 1px;
          height: 100%;
        }
        &::before{
          top: 0;
          left: -100%;
          background-image: linear-gradient(90deg, transparent, var($color));
          animation: one 4s linear infinite;
        }
        i:nth-child(1){
          top: -100%;
          right: 0;
          background-image: linear-gradient(180deg, transparent, var($color));
          animation: two 4s linear 1s infinite;
        }
        &::after{
          bottom: 0;
          right: -100%;
          background-image: linear-gradient(-90deg, transparent, var($color));
          animation: three 4s linear 2s infinite;
        }
        i:nth-child(2){
          bottom: -100%;
          left: 0;
          background-image: linear-gradient(360deg, transparent, var($color));
          animation: four 4s linear 3s infinite;
        }
      }
    }
  }

  .top-option{
    width: 250px;
  }

  .dashboard-group-mes {
    @media (min-width: (map-get($grid-breakpoints, md))) {
      display: flex;
      margin-bottom: 50px;
      & > div {
        display: flex;
      }
    }

    @include dashboard-group-mes-color(--base);
  }

  .dashboard-group-erp {
    @media (min-width: (map-get($grid-breakpoints, md))) {
      display: flex;
      margin-bottom: 50px;
      & > div {
        display: flex;
      }
    }

    @include dashboard-group-mes-color(--base2);
  }
}
@keyframes one {
  0% {
    left: -100%;
  }
  50%, 100% {
    left: 100%;
  }
}
@keyframes two {
  0% {
    top: -100%;
  }
  50%, 100% {
    top: 100%;
  }
}
@keyframes three {
  0% {
    right: -100%;
  }
  50%, 100% {
    right: 100%;
  }
}
@keyframes four {
  0% {
    bottom: -100%;
  }
  50%, 100% {
    bottom: 100%;
  }
}

</style>